<template>
    <Suspense timeout="0">
        <template #default>
            <div class="top_news">
                <h2 class="news_ttl">お知らせ</h2>
                <ul class="news_links clearfix">
                    <li>
                        <router-link
                            :to="{
                                name: 'News',
                            }"
                            >お知らせ一覧</router-link
                        >
                    </li>
                </ul>
                <div class="news_inner">
                    <div v-if="newsError" class="news_error">
                        <el-icon
                            :size="15"
                            color="#f16868"
                            class="el-icon-warning"
                        />
                        お知らせ情報の取得に失敗しました。
                    </div>
                    <div
                        v-else
                        v-for="(item, index) in newsItems"
                        :key="item.title"
                        :id="index"
                    >
                        <dl class="views-row">
                            <dt>
                                {{ item.date }}
                            </dt>
                            <dd>
                                <router-link
                                    :to="{
                                        name: 'NewsDetail',
                                        params: {
                                            id: item.date.replace(/-/g, ''),
                                        },
                                    }"
                                >
                                    {{ item.title }}
                                </router-link>
                            </dd>
                        </dl>
                    </div>
                </div>
            </div>
        </template>
    </Suspense>
</template>

<script>
import SearchApiService from "@/services/SearchApiService.js";
import { defineComponent } from "vue";

export default defineComponent({
    name: "NewsItems",
    async setup() {
        // ニュース一覧を取得する
        let newsItems = [];
        let newsError = false;
        let apiResponse = await SearchApiService.getNewsList();
        if (apiResponse) {
            if (apiResponse.status == 204) {
                newsItems = [];
            } else {
                newsItems = apiResponse.data.response.results;
            }
            newsError = false;
        } else {
            newsItems = [];
            newsError = true;
        }

        return { newsItems, newsError };
    },
});
</script>

<style scoped>
.top_news {
    position: relative;
}
.top_news .news_ttl {
    border-bottom: 1px solid #aaa;
    color: #333;
    font-size: 121.42%;
    font-weight: bold;
    padding: 0 0 5px 37px;
    margin-bottom: 0;
    line-height: 1.5;
    background: url("../../../public/images/icon_top_news.gif") no-repeat 6px
        2px;
}
.top_news .news_links {
    position: absolute;
    top: 0;
    right: 3px;
}
.top_news .news_links a {
    background: no-repeat 0 1px;
    background-image: url("../../../public/images/icon_list.gif");
    padding-left: 22px;
}
.top_news .news_inner dt {
    display: table-cell;
    vertical-align: top;
    width: 130px;
}
.top_news .news_inner dl {
    padding: 15px 0;
    border-bottom: 1px dashed #bbb;
    display: table;
    width: 100%;
    line-height: 1.6;
}
.news_error {
    padding-top: 10px;
}
</style>
